export interface SecondaryMuscle {
  value: string;
  name: string;
}

export const SecondaryMuscles: SecondaryMuscle[] = [
  {
    value: "CHEST",
    name: "חזה"
  },
  {
    value: "ARMS",
    name: "ידיים"
  },
  {
    value: "BACK",
    name: "גב"
  },
  {
    value: "SHOULDERS",
    name: "כתפיים"
  },
  {
    value: "LOWER_ARM",
    name: "יד אחורית"
  },
  {
    value: "FRONT_ARM",
    name: "יד קדמית"
  },
  {
    value: "UPPER_LEGS",
    name: "רגליים-שרשרת קדמית"
  },
  {
    value: "LOWER_LEGS",
    name: "רגליים-שרשרת אחורית"
  },
  {
    value: "BUT",
    name: "ישבן"
  },
  {
    value: "CALVES",
    name: "תאומים"
  },
  {
    value: "ABS",
    name: "בטן"
  },
  {
    value: "CARDIO",
    name: "קרדיו"
  },
]